module.exports = __webpack_public_path__ + "static/media/150.566aabd8.wav";